module.exports = __webpack_public_path__ + "static/media/002-Desinfizieren_ID_3.eb1c666b.mp3";